// removed by extract-text-webpack-plugin
module.exports = {"blue":"hover__blue___1LFBX c-white--hover bg-blue--hover","green":"hover__green___3uhYh c-white--hover bg-green--hover","red":"hover__red___2nm0f c-white--hover bg-red--hover","silver":"hover__silver___MtK4R c-white--hover bg-silver--hover","slate":"hover__slate___gKW0f c-white--hover bg-slate--hover","white":"hover__white___1OJk5 c-slate--hover bg-white--hover","dropbox":"hover__dropbox___2jUG6 c-white--hover bg-dropbox--hover","facebook":"hover__facebook___19-nb c-white--hover bg-facebook--hover","google":"hover__google___k-XcQ c-white--hover bg-google--hover"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/hover.css
// module id = 116
// module chunks = 0 2